export default __webpack_public_path__ + "static/media/StepCompleted.a86df161.svg";